<template>
  <label class="feedback-toggle">
    <input
      :checked="send_feedback_after_treatment"
      @change="handleToggle($event.target.checked)"
      type="checkbox">
    <span class="toggle-slider"></span>
    <div class="toggle-content">
      <span class="toggle-label">Trimite feedback form wapp</span>
      <span v-if="!feedback_after_treatment_sent_at" class="sent-date">{{ feedback_after_treatment_sent_at }}</span>
    </div>
  </label>
</template>

<script>
  import {formatRomanianDate} from "@/mixins/utils";
  export default {
    name: "feedback-toggle"  ,
    computed: {
      send_feedback_after_treatment () {
        return this.$store.state?.pacient.send_feedback_after_treatment
      },
      feedback_after_treatment_sent_at() {
        const isoDate = this.$store.state.pacient.feedback_after_treatment_sent_at
        if (isoDate) {
          return `(ultima: ${formatRomanianDate(isoDate)})`
        }
        return ''
      },
    },
    methods: {
      handleToggle (value) {
        this.$store.dispatch('update_pacient', { send_feedback_after_treatment: value })
      },
    }
  }
</script>

<style lang="less">
@import "../assets/styles/var";

.feedback-toggle {
  @media only screen and (min-width: 0) {
      font-size: 14px;
      padding-left: 15px;
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;

      .toggle-content {
        display: flex;
        align-items: center;
        gap: 4px;
      }

      .sent-date {
        display: block;
        font-size: 12px;
      }
      > input[type="checkbox"] {
        opacity: 0;
        width: 0;
        height: 0;
        position: absolute;

        &:checked + .toggle-slider {
          background-color: @main-green;

          &:before {
            transform: translateX(20px);
          }
        }
      }

      .toggle-slider {
        position: relative;
        display: inline-block;
        width: 35px;
        height: 17px;
        background-color: #ccc;
        border-radius: 24px;
        transition: .3s;
        margin-right: 10px;

        &:before {
          content: "";
          position: absolute;
          height: 7px;
          width: 7px;
          left: 3px;
          bottom: 5px;
          background-color: white;
          border-radius: 50%;
          transition: .3s;
        }
      }

      .toggle-label {
        user-select: none;
      }
    }
  }
</style>
